import { zUsdCents } from "@redotech/money/usd-amounts";
import * as z from "zod";

export const getBaseSupportPredictedPriceInfo = {
  name: "getBaseSupportPredictedPriceInfo" as const,
  input: z.null(),
  output: z.object({
    pricingTiers: z.array(
      z.object({ numTickets: z.number(), priceInCents: zUsdCents }),
    ),
    currentBucketIndex: z.number(),
  }),
};
